import { Spacer } from "shared/layout";
import { colors, space } from "shared/styles/constants";
import styled from "styled-components";

export const StyledRelatedEventBanner = styled(Spacer)`
  padding: ${space.m} ${space.l};
  background-color: ${colors.blackLight};

  > * {
    flex: 0 0 auto;
  }
`;
